import React from 'react';
import './index.less';

class ABSDotIcon extends React.Component {
  render() {
    return (
      <div className="abs-dot">
        <div className="abs-inner-dot" />
      </div>
    );
  }
}

export default ABSDotIcon;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAnchorPoint/components/ABSDot/index.tsx